import type { ExternalSiteRule } from "../../types";
import { SITE_TYPE } from "./const";

const oopy: ExternalSiteRule = {
  type: SITE_TYPE,

  // TODO: OOPY 지원
  getInfo: async ({ html, responseUrl }) => {
    // html 안에서 oopy를 감지하는 방법이 제한됨. 가장 확률이 높은 방법 채택
    if (!html.innerHTML.includes("window.__OOPY__")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [],
};

export default oopy;
